/**
 * Logica PURA condivisa per la risposta a una selettiva (POST /respond),
 * usata sia dalla PWA (axios) sia dal wrapper mobile (fetch). Estrae l'unica
 * parte realmente comune — l'interpretazione dello status/body e il conflitto
 * 409 "AlreadyActiveOnAnother" — evitando la magic-string duplicata (A7.3).
 *
 * NB: l'I/O (client HTTP, token), il GPS e la UI restano platform-specific
 * (vedi ADR-014): qui niente dipendenze da axios/fetch/React Native.
 */

/** Errore restituito dal backend quando l'utente e' gia' attivo su un'altra selettiva. */
export const SELECTIVE_CONFLICT_ERROR = 'AlreadyActiveOnAnother';

export interface SelectiveConflictBody {
  error?: string;
  activeSelectiveId?: string;
  activeSelectiveType?: string;
  activeSelectiveZone?: string;
}

export type SelectiveRespondResult =
  | { kind: 'success' }
  | {
      kind: 'conflict';
      activeSelectiveId: string;
      activeSelectiveType: string;
      activeSelectiveZone?: string;
    }
  | { kind: 'error'; message: string };

/**
 * Interpreta status HTTP + body di POST /selectives/{id}/respond in un
 * risultato tipato. Il chiamante fa solo `switch (result.kind)`.
 */
export function parseRespondResult(
  status: number,
  body: SelectiveConflictBody | null | undefined,
): SelectiveRespondResult {
  if (status >= 200 && status < 300) return { kind: 'success' };
  if (status === 409 && body?.error === SELECTIVE_CONFLICT_ERROR && body.activeSelectiveId) {
    return {
      kind: 'conflict',
      activeSelectiveId: body.activeSelectiveId,
      activeSelectiveType: body.activeSelectiveType ?? 'Altra',
      activeSelectiveZone: body.activeSelectiveZone,
    };
  }
  return { kind: 'error', message: `Errore ${status}` };
}
